<!--定时红包 倒计时弹窗 -->
<template>
  <div class="plv-ia-container plv-ia-rpr-delay">
    <img v-if="selfRedpackType === tabType.rain" class="plv-ia-rpr-rain-delay-img" src="./images/rp-rain-delay-time.png" />
    <img v-else-if="selfRedpackType === tabType.password" class="plv-ia-rpr-delay-img" src="./images/rp-password-delay-time.png" />
    <img v-else class="plv-ia-rpr-delay-img" src="./images/rp-normal-delay-time.png" />
    <div class="plv-ia-rpr-delay-time">
      倒计时：<span class="plv-ia-rpr-delay-time-min">{{ calcDelay.min }}</span>分<span class="plv-ia-rpr-delay-time-second">{{ calcDelay.second }}</span>秒
    </div>
  </div>
</template>

<script>
import redpacketDelay from '../../mixins/redpacket-delay';
export default {
  name: 'RedpacketDelay',
  mixins: [redpacketDelay],
  props: {
    redpackTypeVal: {
      type: String,
      default: 'OFFICIAL_NORMAL'
    }
  },
  watch: {
    redpackTypeVal: {
      handler(val) {
        if (val) {
          this.selfRedpackType = val;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.plv-ia-rpr-delay {
  padding: 24px 0 46px 0;
  margin: auto;
  text-align: center;
}
.plv-ia-rpr-rain-delay-img {
  width: 200px;
  height: 150px;
}
.plv-ia-rpr-delay-img {
  width: 82px;
  height: 110px;
  margin-top: 41px;
}
.plv-ia-rpr-delay-time {
  font-size: 14px;
  span {
    font-size: 24px;
    color: #45acff;
    line-height: 31px;
  }
}
.plv-ia-rpr-delay-time-min {
  margin-right: 4px;
}
.plv-ia-rpr-delay-time-second {
  margin: 0 4px 0 8px;
}
</style>
